<template>
	<div class="layout">
		<div class="list-base">
			<div class="list-base-left">
				<Tag color='magenta' size='large' v-show="documentItem.checkState == 1">已创建</Tag>
				<Tag color='red' size='large' v-show="documentItem.checkState == 2">已审核</Tag>
				<Tag color='success' size='large' v-show="documentItem.checkState == 3">已完结</Tag>
				<span class="list-base-left-span">销售订单：{{documentItem.code}}</span>
			</div>
			<div class="list-base-right">
				<span class="list-base-right-span">
					业务员：
					<span class="span-back-color">{{documentItem.userName}}</span>
				</span>
				<span class="list-base-right-span">
					业务日期：
					<span class="span-back-color">{{documentItem.businessDate}}</span>
				</span>
			</div>
		</div>
		<div class='list-module'>
			<div class="div-title">
				<div class="div-title-label">
					基础信息
				</div>
			</div>
			<Row class="div-content-row">
			    <Col span="8">单据编号：{{documentItem.code}}</Col>
			    <Col span="8">业务日期：{{documentItem.businessDate}}</Col>
			    <Col span="8">业务员：{{documentItem.userName}}</Col>
			</Row>
			<Row class="div-content-row">
			    <Col span="8">客户：{{documentItem.customerName}}</Col>
			    <Col span="8">备注：{{documentItem.note}}</Col>
			</Row>
		</div>
		<div class="list-module">
			<div class="div-title">
				<div class="div-title-label">
					商品信息
				</div>
			</div>
			<Table :columns="commodityColumn" :data="documentItem.salesPlanDetailList"></Table>
		</div>
		<div class="list-module">
			<div class="div-title">
				<div class="div-title-label">
					套餐信息
				</div>
			</div>
			<Table :columns="commodityPackageColumn" :data="documentItem.salesPlanPackageList"></Table>
		</div>
		<div class="list-module">
			<div class="div-title">
				<div class="div-title-label">
					结算信息
				</div>
			</div>
			<Row class="div-content-row-center">
				<Col span="8">应收金额：<span class="amount-color">{{documentItem.amount}}</span></Col>
				<Col span="8">已收定金：<span class="amount-color">{{documentItem.deposit}}</span></Col>
				<Col span="8">待收金额：<span class="amount-color">{{documentItem.amount - documentItem.deposit}}</span></Col>
			</Row>
			<div class="div-content-detail">
				<div class="div-content-detail-title">
					付款详情
				</div>
				<div class="div-content-detail-list" v-show="documentItem.deposit>0">
					<div class="div-content-detail-list-title">定金</div>
					<div class="div-content-detail-list-content">
						<div class="div-content-detail-list-content-item">
							付款日期：
							<span class="span-back-color">
								{{documentItem.businessDate}}
							</span>
						</div>
						<div class="div-content-detail-list-content-item">
							{{documentItem.payWay}}：
							<span class="span-back-color">
								¥&nbsp;{{documentItem.deposit}}
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="list-module">
			<div class="div-title">
				<div class="div-title-label">
					附件信息
				</div>
			</div>
			<DocumentFile :fileList='documentItem.fileList' :isShow='true'></DocumentFile>
		</div>
	</div>
</template>

<script>
	import request from '@/utils/request'
	import DocumentFile from '@/components/DocumentFile'
	export default {
		name: 'salesplanlistdetail',
		components: {
			DocumentFile
		},
		data() {
			return {
				documentItem: {
					id: 0,
					code: '',
					businessDate: '',
					amount: 0,
					deposit: 0,
					salesPlanDetailList: [],
					salesPlanPackageList: [],
					customerId: '',
					customerName: '',
					customerDiscount: '100',
					userId: '',
					userName: '',
					creator: parseInt(localStorage.getItem("userId")),
					note: '',
					payWay: '',
					checkState: 1, //未审核
					fileList: []
				},
				commodityColumn: [
					{
					    title: '商品',
					    key: 'name',
						fixed: 'left',
						width: 345
					},
					{
						title: '单位',
						key: 'unit',
						width: 130
					},
					{
						title: '规格',
						key: 'format',
						width: 140,
					},
					{
						title: '当前库存',
						key: 'stock',
						width: 140,
					},
					{
						title: '数量',
						key: 'quantity',
						width: 130
					},
					{
						title: '单价',
						key: 'price',
						width: 140
					},
					{
						title: '折扣(%)',
						key: 'discount',
						width: 140
					},
					{
						title: '折后单价',
						key: 'priceAfterDiscount',
						width: 140
					},
					{
						title: '总金额',
						key: 'amount',
						width: 200
					},
					{
						title: '备注',
						key: 'note',
						width: 350,
					}
				],
				commodityPackageColumn: [
					{
						title: '套餐商品',
						key: 'name',
						fixed: 'left',
						width: 345
					},
					{
						title: '单位',
						key: 'unit',
						width: 130
					},
					{
						title: '套餐种类',
						key: 'type',
						width: 200,
					},
					{
						title: '数量',
						key: 'quantity',
						width: 130
					},
					{
						title: '单价',
						key: 'price',
						width: 140
					},
					{
						title: '折扣(%)',
						key: 'discount',
						width: 140
					},
					{
						title: '折后单价',
						key: 'priceAfterDiscount',
						width: 140
					},
					{
						title: '总金额',
						key: 'amount',
						width: 200
					},
					{
						title: '备注',
						key: 'note',
						width: 400,
					}
				]
			}
		},

		methods: {
			getPlanList(planListId) {
				let self = this;
				request.get('/api/SalesPlanList/GetSalesPlanList', {
					params: {
						id: planListId
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: response.errorMsg
						});
						return;
					}
					self.documentItem = response.data;
				}).catch(function(error) {})
			},
			getPlanListByCode(planListCode) {
				let self = this;
				request.get('/api/SalesPlanList/GetSalesPlanListByCode', {
					params: {
						code: planListCode
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: response.errorMsg
						});
						return;
					}
					self.documentItem = response.data;
				}).catch(function(error) {})
			}
		},
		watch: {
			'$route.query.planListId':{
				immediate: true,
				handler(param) {
					if(param){
						this.getPlanList(param);
					}
				}
			},
			'$route.query.planListCode':{
				immediate: true,
				handler(param) {
					if(param){
						this.getPlanListByCode(param);
					}
				}
			}
		},
		created: function() {
		}
	}
</script>

<style scoped>
	.layout {
		border-radius: 8px;
	}
	
	.list-base{
		background-color: white;
		padding: 15px;
		overflow: hidden;
	}
	
	.list-base-left{
		float: left;
		display: flex;
		color: #000;
		justify-content: center; /* 水平居中 */
		align-items: center;    /* 垂直居中 */
		height: 100%;           /* 父元素需要固定高度或其他百分比高度 */
	}
	
	.list-base-left-span{
		font-size: 18px;
	}
	
	.list-base-right{
		display: flex;
		float: right;
		justify-content: center; /* 水平居中 */
		align-items: center;    /* 垂直居中 */
		height: 36px;     
	}
	
	.list-base-right-span{
		margin-left: 10px;
	}
	
	.span-back-color{
		color: #000;
	}
	
	.div-title {
		border-bottom: 1px solid #ebeef5;
		margin-bottom: 20px;
	}
	
	.div-title-label {
		border-left: 2px solid rgb(255, 106, 127);
		text-indent: 0.5em;
		font-weight: bold;
	}
	
	.list-module{
		background-color: white;
		margin-top: 20px;
		padding: 15px;
	}
	
	.div-content-row div{
		padding: 15px;
	}
	
	.div-content-row-center div{
		padding: 15px;
		text-align: center;
		font-size: 16px;
		color: #000;
		font-weight: bold;
	}
	
	.amount-color{
		color: rgb(255, 106, 127);
	}
	
	.div-content-detail{
		margin: 15px;
		background-color:#f8f8f9;
		padding: 20px;
	}
	
	.div-content-detail-title{
		text-indent: 0.5em;
		font-weight: bold;
		border-bottom: 1px solid #ebeef5;
	}
	.div-content-detail-list{
		margin-top: 10px;
	}
	.div-content-detail-list-title{
		text-indent: 0.5em;
	}
	
	.div-content-detail-list-content{
		overflow: hidden;
	}
	
	.div-content-detail-list-content-item{
		float: left;
		width: 30%;
		padding: 10px;
		text-align: center;
	}
</style>